import { find, findIndex, forEach, get, isEqual, isNil } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import ValueView from './ValueView';
import styles from './SelectBoxValueView.scss';
import { RETURN_TYPE } from '../base/SelectBox';
import StatusAddon from '../../dataViews/NextTree/addons/StatusAddon';
import Statuses from '../../../../model/Statuses';
import useT from '../../utils/Translations/useT';
function SelectBoxValueView({ label = '', value = null, defaultValue, itemTitlePropName = 'name', itemValuePropName = 'value', itemStatusPropName = 'status', groupTitleKeys = [], hasInputOptionGroup = false, options = [], returnType = RETURN_TYPE.STRING, onOptionTitle, valueClassName, noLabel, title: tooltipTitle = '', disableTitleTooltip = false, }) {
    const t = useT();
    const handleSelectBox = useCallback(value => {
        let index = -1;
        forEach(options, (option, key) => {
            const i = findIndex(option, o => o[itemValuePropName] === value);
            if (i !== -1) {
                index = key;
            }
        });
        return index >= 0
            ? `${(find(options[index], o => o[itemValuePropName] === value) || {})[itemTitlePropName]}, ${groupTitleKeys[index]}`
            : null;
    }, [itemValuePropName, groupTitleKeys, itemTitlePropName, options]);
    const selectedValue = isNil(value) ? defaultValue : value;
    const comparator = useCallback(option => returnType === RETURN_TYPE.OPTION
        ? isEqual(option, selectedValue)
        : isEqual(option[itemValuePropName], selectedValue), [itemValuePropName, returnType, selectedValue]);
    const optionByValue = useMemo(() => {
        for (const group of options) {
            if (Array.isArray(group)) {
                for (const option of group) {
                    if (comparator(option)) {
                        return option;
                    }
                }
            }
            else {
                if (comparator(group)) {
                    return group;
                }
            }
        }
        if (!value) {
            return { option: null };
        }
        if (returnType === RETURN_TYPE.OPTION) {
            return value;
        }
        return { option: { [itemValuePropName]: value } };
    }, [returnType, value, itemValuePropName, comparator, options]);
    const selectedTitle = useMemo(() => {
        if (hasInputOptionGroup) {
            return handleSelectBox(selectedValue);
        }
        if (onOptionTitle) {
            return onOptionTitle(optionByValue);
        }
        return get(optionByValue, itemTitlePropName, t('None'));
    }, [
        t,
        onOptionTitle,
        selectedValue,
        itemTitlePropName,
        handleSelectBox,
        hasInputOptionGroup,
        optionByValue,
    ]);
    const renderAddon = useCallback(() => (<StatusAddon status={(optionByValue && optionByValue[itemStatusPropName]) ||
        Statuses.Active.value}/>), [optionByValue, itemStatusPropName]);
    return (<ValueView addonClassName={styles.addon} disableTitleTooltip={disableTitleTooltip} label={label} noLabel={noLabel} renderAddon={optionByValue && optionByValue[itemStatusPropName] && renderAddon} title={tooltipTitle} value={selectedTitle} valueClassName={valueClassName}/>);
}
export default SelectBoxValueView;
